export default __webpack_public_path__ + "c7eda43dd738260234976ad125fbfeb3.ttf";